export const MEGABATTLE_QUESTION_REQUEST = "MEGABATTLE_QUESTION_REQUEST";
export const MEGABATTLE_QUESTION_SUCCESS = "MEGABATTLE_QUESTION_SUCCESS";
export const  MEGABATTLE_QUESTION_FAILURE = "MEGABATTLE_QUESTION_FAILURE";